// @ts-strict-ignore
import { useState } from 'react'

import { useSession } from '@/entities/session'

import { mindBoxSDK } from '@/shared/integrations/mindBox'
import { getPhoneFromJwtToken } from '@/shared/lib/utils/jwt/get-phone-from-jwt-token'

import { TradeInContent } from '../trade-in-content/trade-in-content'
import { TradeInForm } from '../trade-in-form/trade-in-form'

import cl from './style.module.scss'

export const SectionTradeIn = () => {
	const [benefitPrice, setBenefitPrice] = useState<number>(0)
	const { currentSession } = useSession()

	const onSubmitHadler = (price = 0, info = '') => {
		const userPhone = getPhoneFromJwtToken(currentSession?.token)

		setBenefitPrice(price)

		if (!!price) {
			mindBoxSDK.sendSuccessTradeInCalculate({
				sum: price,
				urlPage: 'https://www.iport.ru/services/trade-in/',
				additionalInformation: info,
				userPhone
			})
		}
	}

	return (
		<section className={cl.section}>
			<h2 className={cl.title}>Калькулятор стоимости</h2>

			<div className={cl.body}>
				<div className={cl.wrapper}>
					<h3 className={cl.title}>Выберите ваше устройство</h3>
					<TradeInForm onSubmit={onSubmitHadler} />
				</div>

				<TradeInContent price={benefitPrice} />
			</div>
		</section>
	)
}
